import { useNavigate } from 'react-router';
import { useRef } from 'react';
import { RouteNavigatorService } from './routeNavigatorService';

export const useRouteNavigator = () => {
  const navigate = useNavigate();
  const serviceRef = useRef<RouteNavigatorService | null>(null);

  if (!serviceRef.current) {
    serviceRef.current = new RouteNavigatorService(navigate);
  }

  return serviceRef.current;
};
